import { useState, useEffect } from "react";
import { updateUserInfo, getUserInfo } from "../../../api/User";
import { toast } from "react-toastify";
import AffiliateSection from "./AffiliateSection";

export default function AccountInfoTab() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [avatar, setAvatar] = useState<string>(
        "https://cdn-web-next.thuocsi.vn/images/home/avatar.svg"
    );
    const [avatarFile, setAvatarFile] = useState<File | undefined>();

    const fetchUserData = async () => {
        const data = await getUserInfo();
        if (data) {
            setName(data.info.fullname || "");
            setEmail(data.info.email || "");
            setPhone(data.info.phone || "");
            setDateOfBirth(data.info.birthday || "");
            if (data.info.avatar) {
                setAvatar(data.info.avatar);
            }
            // Update local storage if needed
            localStorage.setItem('user', JSON.stringify(data.info || {}));
        }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    const handleAvatarChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setAvatarFile(file);
        const previewUrl = URL.createObjectURL(file);
        setAvatar(previewUrl);
    };

    const handleUpdate = async () => {
        try {
            await updateUserInfo({
                fullname: name,
                phone: phone,
                dob: dateOfBirth,
                avatar: avatarFile,
            });
            toast.success("Cập nhật thông tin thành công.", {
                position: "bottom-right",
            });
            await fetchUserData(); // Refresh data and local storage
        } catch (error) {
            toast.error("Cập nhật thông tin thất bại. Vui lòng thử lại.", {
                position: "bottom-right",
            });
            console.error("Failed to update user info:", error);
        }
    };

    return (
        <div
            className="MuiTabPanel-root styles_tab_panel__NZzZm"
            role="tabpanel"
            aria-labelledby="mui-p-22758-T-1"
            id="mui-p-22758-P-1"
        >
            <div style={{ display: "flex", gap: 24, margin: "30px 0px", flexWrap: "wrap" }}>
                {/* Cột trái: Thông tin tài khoản */}
                <div style={{ flex: "1 1 55%", minWidth: 300, textAlign: "center" }}>
                {/* Avatar */}
                <div className="flex justify-center mb-[10px]">
                    <div className="group relative rounded-full w-[150px] h-[150px] overflow-hidden">
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: 0,
                                margin: 0,
                                padding: 0,
                                position: "absolute",
                                inset: 0,
                            }}
                        >
                            <img
                                alt="Avatar"
                                src={avatar}
                                decoding="async"
                                style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    padding: 0,
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: 0,
                                    height: 0,
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        </span>

                        <div className="opacity-0 group-hover:opacity-100 transition-all absolute top-0 bottom-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 rounded-full">
                            <label
                                htmlFor="avatar-upload"
                                className="cursor-pointer h-full w-full flex items-center justify-center"
                            >
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium !text-white css-vubbuv"
                                    focusable="false"
                                    aria-hidden="true"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z" />
                                </svg>
                            </label>
                            <input
                                type="file"
                                id="avatar-upload"
                                className="hidden"
                                accept="image/png, image/jpeg, image/jpg"
                                onChange={handleAvatarChange}
                            />
                        </div>
                    </div>
                </div>

                {/* Họ tên */}
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label
                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required"
                        htmlFor="name"
                        id="name-label"
                    >
                        Họ và tên khách hàng
                        <span aria-hidden="true" className="MuiInputLabel-asterisk">
                            &thinsp;*
                        </span>
                    </label>
                    <div className="MuiInputBase-root MuiFilledInput-root jss36 MuiInputBase-formControl">
                        <input
                            id="name"
                            required
                            type="text"
                            className="MuiInputBase-input MuiFilledInput-input"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                </div>

                {/* Phone */}
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label
                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required"
                        htmlFor="phone"
                        id="phone-label"
                    >
                        Số điện thoại
                        <span aria-hidden="true" className="MuiInputLabel-asterisk">
                            &thinsp;*
                        </span>
                    </label>
                    <div className="MuiInputBase-root MuiFilledInput-root jss36 MuiInputBase-formControl">
                        <input
                            id="phone"
                            required
                            type="text"
                            className="MuiInputBase-input MuiFilledInput-input"
                            value={phone}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                setPhone(value);
                            }}
                        />
                    </div>
                </div>

                {/* Email */}
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label
                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled Mui-disabled MuiFormLabel-filled"
                        htmlFor="email"
                        id="email-label"
                    >
                        Email
                    </label>
                    <div className="MuiInputBase-root MuiFilledInput-root jss36 Mui-disabled MuiInputBase-formControl">
                        <input
                            disabled
                            id="email"
                            type="text"
                            className="MuiInputBase-input MuiFilledInput-input Mui-disabled"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                </div>

                {/* Alert */}
                <div
                    className="MuiPaper-root MuiAlert-root MuiAlert-standardWarning MuiPaper-elevation0"
                    role="alert"
                    style={{
                        width: "80%",
                        borderRadius: "8px",
                        display: "inline-flex",
                        justifyContent: "flex-start",
                    }}
                >
                    <div className="MuiAlert-icon">
                        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"></path></svg>
                    </div>
                    <div className="MuiAlert-message">
                        <p
                            className="MuiTypography-root MuiTypography-body1 MuiTypography-alignCenter"
                            style={{ fontSize: "12px", padding: 0 }}
                        >
                            Vui lòng liên hệ{" "}
                            <a href="tel:18002038" style={{ textDecoration: "none" }}>
                                1800 2038
                            </a>{" "}
                            để được hỗ trợ thay đổi email.
                        </p>
                    </div>
                </div>

                {/* Ngày sinh */}
                <div className="styles_wrapperInput__7wCA2">
                    <div className="MuiFormControl-root MuiTextField-root jss35 styles_inputDate__Q44N_">
                        <label
                            className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled"
                            htmlFor="dateOfBirth"
                            id="dateOfBirth-label"
                        >
                            Ngày sinh
                        </label>
                        <div className="MuiInputBase-root MuiFilledInput-root jss36 MuiInputBase-formControl">
                            <input
                                id="dateOfBirth"
                                placeholder="Ví dụ: 1999-12-31"
                                type="text"
                                maxLength={10}
                                inputMode="numeric"
                                className="MuiInputBase-input MuiFilledInput-input"
                                value={dateOfBirth}
                                onChange={(e) => setDateOfBirth(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* Button */}
                <div style={{ margin: "30px 0px" }}>
                    <button
                        className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR my-order__button my-order__button--green bg-gradient"
                        type="button"
                        onClick={handleUpdate}
                    >
                        <span className="MuiButton-label">Cập nhật</span>
                        <span className="MuiTouchRipple-root" />
                    </button>
                </div>
                </div>

                {/* Cột phải: Affiliate */}
                <div style={{
                    flex: "1 1 35%",
                    minWidth: 280,
                    borderLeft: "1px solid #e8e8e8",
                    paddingLeft: 24,
                }}>
                    <AffiliateSection />
                </div>
            </div>
        </div>
    );
}
